import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'
import { me, login as apiLogin, logout as apiLogout, type User } from '../api/auth'
import { authStore } from '../api/client'

type AuthState = {
  user: User | null
  loading: boolean
  login: (username: string, password: string) => Promise<User>
  logout: () => void
}

const AuthContext = createContext<AuthState | undefined>(undefined)

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!authStore.getToken()) {
      setLoading(false)
      return
    }
    me()
      .then(setUser)
      .catch(() => authStore.clear())
      .finally(() => setLoading(false))
  }, [])

  async function login(username: string, password: string) {
    const u = await apiLogin(username, password)
    setUser(u)
    return u
  }

  function logout() {
    setUser(null)
    apiLogout()
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth doit être utilisé dans un <AuthProvider>')
  return ctx
}
